// The preview of a composed landing page is a PAGE, so it renders as one: in a frame of its own,
// with the theme's stylesheet and nothing else.
//
// Rendered inline, under the tool's answer panel, the blocks lost the rules a page gives them and
// took the panel's instead: a section is a plate with its own vertical rhythm only when it is a
// child of `main`, and inside a container it is a bare block with the container's gap; the answer
// panel then painted its own tint under the hero's stage, and a title landed in the first column of
// the grid it was meant to head. Measured on fastast on the first day the tool was out. Rewriting
// the page rules for a nested context would be a second copy of the theme, kept in step by hand.
//
// So the blocks are handed to a same-origin frame — `srcdoc`, the page's own stylesheet, a `main`
// like a public page's — where every rule of the theme applies exactly as it would on a page with
// an address. The frame grows to its document and follows it (a FAQ unfolds). The inline blocks
// stay where they are until the frame has drawn something, so a browser that cannot frame (a
// policy, a very old engine) keeps the fallback rather than nothing.

function frameOf(holder, source, sheet) {
	const lang = document.documentElement.getAttribute('lang') || '';
	const frame = document.createElement('iframe');
	frame.className = 'ui-embed-iframe';
	frame.title = holder.dataset.landingPreviewTitle || '';
	frame.style.width = '100%';
	frame.style.height = '0';
	frame.style.border = '0';
	frame.srcdoc = '<!doctype html><html lang="' + lang + '"><head><meta charset="utf-8">'
		+ '<meta name="viewport" content="width=device-width, initial-scale=1">'
		+ '<base target="_top">'
		+ '<link rel="stylesheet" href="' + sheet.href + '"></head>'
		+ '<body class="arcate-full"><main role="main">' + source.innerHTML + '</main></body></html>';
	return frame;
}

document.querySelectorAll('[data-landing-preview]').forEach((holder) => {
	const source = holder.querySelector('[data-landing-preview-source]');
	const sheet = document.querySelector('link[rel="stylesheet"]');
	if (!source || !sheet || !('srcdoc' in document.createElement('iframe'))) return;

	const frame = frameOf(holder, source, sheet);
	const sync = () => {
		const doc = frame.contentDocument;
		if (!doc || !doc.documentElement) return;
		const height = Math.max(doc.documentElement.scrollHeight, doc.body ? doc.body.scrollHeight : 0);
		if (height > 0) frame.style.height = height + 'px';
	};
	frame.addEventListener('load', () => {
		const doc = frame.contentDocument;
		if (!doc || !doc.body || doc.body.scrollHeight === 0) return;
		sync();
		source.hidden = true;
		if (window.ResizeObserver) new ResizeObserver(sync).observe(doc.documentElement);
		if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(sync);
	});
	holder.appendChild(frame);
});
